import domContentLoaded from 'dom-content-loaded';
import $, { each } from 'jquery';

export default () => {
	$(() => {
		$('.js-slider-voice').slick({
			arrows: false,
			autoplay: true,
			dots: false,
			autoplaySpeed: 0,
			speed: 4000,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 479,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});
	});
};
